import { Component, Input, OnInit, Output } from '@angular/core';
import { TooltipPosition, TooltipTheme } from './ui/enum';

@Component({
  standalone: false,
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
})
export class TooltipComponent{

  position: TooltipPosition = TooltipPosition.DEFAULT;
  theme: TooltipTheme = TooltipTheme.DEFAULT;
  tooltip = '';
  left = 0;
  top = 0;
  visible = false;

  constructor() { }
}